const routes = [
  {
    path: '',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/modules/home/index.vue')
  },
];

export default routes;